<template>
  <div class="create-order">
    <div class="breadcrumb-area pos-relative" style="display: flex; justify-content: space-between">
      <h1>{{ idUpdate ? "Cập nhật" : "Tạo" }} phiếu đặt hàng</h1>
      <div>
        <button type="button" class="btn btn-secondary flex-grow-1 mr-2" @click="cancel">
          Quay lại
        </button>
        <button type="submit" @click="submitForm" class="btn btn-primary flex-grow-1" :disabled="isSubmitting">
          Tạo phiếu
        </button>
      </div>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <div class="ml-3 p-3 mt-2 " style="max-width: 1000px; border: 1px solid #d7d7d7;border-radius: 10px;">
        <div class="card-body p-1">
          <form @submit.prevent="submitForm">
            <b-row>
              <b-col md="6">
                <div class="form-group mb-3">
                  <label for="agentId">Đơn vị nhận hàng <span style="color: red">*</span></label>
                  <!-- <select2 type="text" id="agentId" placeholder="Tìm kiếm..." :options="agentDefault" v-model="formData.agentId"
                    :settings="searchAgent" required @change="loadCategories" /> -->

                    <select2 type="text" id="agentId" placeholder="Tìm kiếm..." :options="agentDefault" v-model="formData.agentId"
                    required @change="loadCategories" />

                  <div v-if="errors.agentId" class="text-danger mt-1">{{ errors.agentId }}</div>
                </div>
                <div class="form-group mb-3">
                  <label for="dateEstimate">Ngày nhận dự kiến <span style="color: red">*</span></label>
                  <input type="date" id="dateEstimate" class="form-control" v-model="formData.dateEstimate" required @focus="openDatePicker" />
                  <div v-if="errors.dateEstimate" class="text-danger mt-1">{{ errors.dateEstimate }}</div>
                </div>
                <div class="form-group mb-3">
                  <label for="note">Ghi chú</label>
                  <textarea id="note" class="form-control" v-model="formData.note" rows="5"></textarea>
                </div>
              </b-col>
              <b-col md="6">
                <div class="order-items-section">
                  <div class="mb-3">
                    <label>Loại thiết bị</label>
                    <label class="float-right">Số lượng</label>
                  </div>
                  <div v-for="(item, index) in orderItems" :key="index" class="mb-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="item-name">{{ item.categoryName }}</div>
                      <input type="number" class="form-control quantity-input" v-model="item.quantity" min="0"
                        style="width: 120px;" @input="validateQuantity(index)" />
                    </div>
                  </div>
                  <div v-if="errors.orderItems" class="text-danger mt-1">{{ errors.orderItems }}</div>
                  <div v-if="loadingCategories" class="mt-2 text-center">Đang tải...</div>

                </div>
              </b-col>
            </b-row>
          </form>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import { CommonService } from '@/services/common.service'
import { DeviceService } from '@/services/device.service'

export default {
  name: 'OrderCreate',
  data () {
    return {
      idUpdate: this.$route.params.id,
      showLoading: false,
      isSubmitting: false,
      errors: {
        agentId: '',
        dateEstimate: '',
        orderItems: ''
      },
      formData: {
        agentId: '',
        dateEstimate: '',
        note: '',
        orderDetail: []
      },
      agentDefault: [],
      partnerCodeMap: [],
      searchAgent: {
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListAgentBank({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              })
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id2: item?.partnerCode,
                          id: item?.agentId,
                          text: item.name || ''
                        }
                      }) || []
                  })

                  this.partnerCodeMap = res.data?.map((item) => {
                    return {
                      partnerCode: item?.partnerCode,
                      agentId: item?.agentId
                    }
                  }) || []
                })
                .catch(failure)
            }, 500)
          }
        }
      },
      orderItems: [],
      loadingCategories: false
    }
  },
  created () {
    this.fetchĐataAgent()
    if (this.idUpdate) {
      this.fetchĐata()
    }
  },
  methods: {
    async fetchĐataAgent () {
      try {
        const data = await CommonService.getListAgentBank({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.agentDefault = data.data.map((item) => {
            return {
              id2: item?.partnerCode,
              id: item?.agentId,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap = data.data.map((item) => {
            return {
              partnerCode: item?.partnerCode,
              agentId: item?.agentId
            }
          }) || []
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    async fetchĐata () {
      this.showLoading = true
      try {
        const data = await DeviceService.DetailOrderFormPartner({ id: this.idUpdate })
        if (data.code === 1000) {
          this.agentDefault = [{
            id: data.data.agentId,
            text: data.data.agentName
          }]
          this.formData.agentId = data.data.agentId
          this.formData.dateEstimate = new Date(data.data.estimatedTime).toISOString().split('T')[0]
          this.formData.note = data.data.note

          this.orderItems = data.data.orderDetail || []
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    },
    async loadCategories (id) {
      this.orderItems = []
      this.loadingCategories = true
      const idPartner = this.partnerCodeMap.find(item => item.agentId === id)?.partnerCode || ''
      try {
        const data = await DeviceService.getListDevicePartner({ partnerCode: idPartner })
        if (data.code === 1000) {
          this.orderItems = data.data.map((item) => {
            return {
              categoryId: item.id,
              categoryName: item.name,
              quantity: 0
            }
          })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.loadingCategories = false
      }
    },
    validateQuantity (index) {
      // Kiểm tra và điều chỉnh giá trị âm thành 0
      if (parseInt(this.orderItems[index].quantity) < 0) {
        this.orderItems[index].quantity = 0
      }
    },
    openDatePicker (event) {
      // Mở picker của input date khi focus
      event.target.showPicker()
    },
    validateForm () {
      let isValid = true
      this.errors = {
        agentId: '',
        dateEstimate: '',
        orderItems: ''
      }

      // Validate đơn vị nhận hàng
      if (!this.formData.agentId || this.formData.agentId.trim() === '') {
        this.errors.agentId = 'Vui lòng chọn đơn vị nhận hàng'
        isValid = false
      }

      // Validate ngày nhận dự kiến
      if (!this.formData.dateEstimate) {
        this.errors.dateEstimate = 'Vui lòng chọn ngày nhận dự kiến'
        isValid = false
      }

      // Kiểm tra xem có ít nhất một thiết bị có số lượng > 0
      const hasValidItem = this.orderItems.some(item => parseInt(item.quantity) > 0)
      if (!hasValidItem) {
        this.errors.orderItems = 'Vui lòng nhập số lượng cho ít nhất một loại thiết bị'
        isValid = false
      }

      return isValid
    },
    submitForm () {
      if (!this.validateForm()) {
        return
      }

      // Chuyển dữ liệu từ orderItems vào formData.orderDetail
      this.formData.orderDetail = this.orderItems.filter(item => parseInt(item.quantity) > 0).map(item => ({
        categoryId: item.categoryId,
        categoryName: item.categoryName,
        quantity: parseInt(item.quantity)
      }))

      // Convert dateEstimate thành timestamp nếu cần
      if (this.formData.dateEstimate) {
        this.formData.dateEstimate = new Date(this.formData.dateEstimate).getTime()
      }

      this.onSubmitAdd(this.formData)
    },
    async onSubmitAdd (params) {
      try {
        this.showLoading = true
        this.isSubmitting = true

        let data
        if (this.idUpdate) {
          // Nếu có idUpdate thì gọi API cập nhật
          params.id = this.idUpdate
          data = await DeviceService.UpdateOrderFormPartner(params)
        } else {
          // Ngược lại gọi API tạo mới
          data = await DeviceService.AddOrderFormPartner(params)
        }

        if (data.code === 1000) {
          const message = this.idUpdate
            ? 'Cập nhật phiếu đặt hàng thành công'
            : 'Tạo phiếu đặt hàng thành công'
          this.showSuccessMx(message).then(() => this.$router.push('/order-form'))
        } else this.showFailMx(data.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
        this.isSubmitting = false
      }
    },
    cancel () {
      this.$router.push('/order-form')
    }
  }
}
</script>

<style scoped>
.form-group label {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.quantity-input {
  text-align: center;
}

.order-items-section {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 15px;
}

.item-name {
  font-weight: 500;
}

label {
  font-size: 14px;
}
</style>
